import { Component, HostBinding, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
    selector: '[lInput]',
    standalone: true,
    template: ``,
    imports: [
        FormsModule,
    ]
})
export class InputComponent {

  @HostBinding('class')
  public get class(): string {
    return this.generateClasses;
  }

  @Input()
  public outline: boolean = false;

  public get generateClasses(): string {
    return 'placeholder:text-lGray600 dark:placeholder:text-lGray600 px-4 w-full bg-lGray950 text-color border-radius focus:ring-1 focus:border-lPrimary dark:focus:border-lPrimaryLight ring-lPrimary dark:ring-lPrimaryLight border border-color text-base h-12 transition-shadow';
  }

}
